import DownloadCompleted from './DownloadCompleted'

export default DownloadCompleted
